<p-autoComplete
    #autocompleteAccounts
    [id]="id()"
    [panelStyleClass]="id() + '-panel'"
    [appendTo]="'body'"
    [lazy]="true"
    [autoHighlight]="true"
    [completeOnFocus]="true"
    [forceSelection]="false"
    [disabled]="disabled()"
    [(ngModel)]="searchValue"
    [fluid]="true"
    [suggestions]="suggestions()"
    [showClear]="searchValue() !== ''"
    [placeholder]="'impersonate.selectUserPlaceholder' | translate"
    [minQueryLength]="0"
    (completeMethod)="getUserSuggestions()"
    (onKeyUp)="$event.keyCode === 13 ? getUserSuggestions() : valueChanged.emit(searchValue())"
    (onSelect)="selectAccount($event.value)"
    (onClear)="clearSelection()">
    <ng-template #item let-user>
        <div class="user-suggestion">
            <ellipsis-tooltip [id]="'user-suggestion-name'">
                <p class="name">{{ user.firstName || '' }} {{ user.lastName || '' }}</p>
            </ellipsis-tooltip>

            <ellipsis-tooltip [id]="'user-suggestion-email'">
                <p class="email">{{ user.email }}</p></ellipsis-tooltip
            >
        </div>
    </ng-template>
    <ng-template #footer>
        @if (suggestions() && suggestions().length > 0) {
            <p class="autocomplete-footer">
                {{ 'impersonate.autocompleteFooter' | translate }}
            </p>
        }</ng-template
    ><ng-template #empty>
        <p class="autocomplete-empty">
            {{ 'impersonate.autocompleteFooter' | translate }}
        </p>
    </ng-template>
</p-autoComplete>
